import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import AwesomeDebouncePromise from 'awesome-debounce-promise'
import Select from 'react-select'
import {
  TextField,
  MenuItem,
  Paper,
  Typography,
} from '@material-ui/core'

import idObjectMapper from '../../utils/IdObjectMapper'
import * as UserActionCreators from '../../actions/user'
import UserNameContainer from './UserNameContainer'

function inputComponent(args) {
  const { inputRef, ...props } = args
  return <div ref={inputRef} {...props} />
}

function Control(args) {
  return (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          className: args.selectProps.classes.input,
          inputRef: args.innerRef,
          children: args.children,
          ...args.innerProps,
        },
      }}
      {...args.selectProps.textFieldProps}
    />
  )
}

function Placeholder(args) {
  return (
    <Typography
      color="textSecondary"
      className={args.selectProps.classes.placeholder}
      {...args.innerProps}
    >
      {args.children}
    </Typography>
  )
}

function NoOptionsMessage(args) {
  return (
    <Typography
      color="textSecondary"
      className={args.selectProps.classes.noOptionsMessage}
      {...args.innerProps}
    >
      {args.children}
    </Typography>
  )
}

function Option(args) {
  return (
    <MenuItem
      className={args.isFocused ? args.selectProps.classes.optionFocus : ''}
      buttonRef={args.innerRef}
      selected={args.isSelected}
      component="div"
      {...args.innerProps}
    >
      {args.children}
    </MenuItem>
  )
}

function SingleValue(args) {
  return (
    <Typography className={args.selectProps.classes.singleValue} {...args.innerProps}>
      {args.children}
    </Typography>
  )
}

function ValueContainer(args) {
  return <div className={args.selectProps.classes.valueContainer}>{args.children}</div>
}

function Menu(args) {
  return (
    <Paper square className={args.selectProps.classes.paper} {...args.innerProps}>
      {args.children}
    </Paper>
  )
}

class UserSelectContainer extends React.Component {
  static propTypes = {
    /* HOC/middleware props */
    classes: PropTypes.object.isRequired,
    /* passed props */
    organizationId: PropTypes.number.isRequired,
    selected: PropTypes.object,
    onSelect: PropTypes.func.isRequired,
    /* mapped state */
    users: PropTypes.object.isRequired,
    userSearches: PropTypes.object.isRequired,
    /* mapped dispatch */
    userActions: PropTypes.object.isRequired,
  }

  static defaultProps = {
    selected: {},
  }

  static styles = (theme) => ({
    root: {
      flexGrow: 1,
      height: 250,
    },
    input: {
      display: 'flex',
      padding: 0,
      height: 'auto',
    },
    valueContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      flex: 1,
      alignItems: 'center',
      overflow: 'hidden',
    },
    noOptionsMessage: {
      padding: theme.spacing(1, 2),
    },
    optionFocus: {
      backgroundColor: theme.palette.action.hover,
    },
    singleValue: {
    },
    placeholder: {
      position: 'absolute',
      left: 2,
    },
    paper: {
      minWidth: '100%',
      width: 'fit-content',
      position: 'absolute',
      left: 0,
      right: 0,
    },
  })

  static mapStateToProps(state) {
    return {
      users: state.users,
      userSearches: state.userSearches,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      userActions: bindActionCreators(UserActionCreators, dispatch),
    }
  }

  state = {
    query: '',
  }

  debouncedListUsers = AwesomeDebouncePromise(this.props.userActions.listOrganizationUsers, 200)

  componentDidMount() {
    this.props.userActions.listOrganizationUsers(this.props.organizationId)
  }

  handleChange = (query) => {
    this.debouncedListUsers(this.props.organizationId, query)
    this.setState({ query })
  }

  users() {
    const { users, userSearches } = this.props
    const { query = '' } = this.state
    return idObjectMapper(userSearches[query], users).sort((a, b) => a.name.localeCompare(b.name))
  }

  render() {
    const { classes, selected, onSelect } = this.props
    const value = selected.user_id ? selected : ''

    return (
      <Select
        classes={classes}
        options={this.users()}
        getOptionLabel={(user) => <UserNameContainer user={user} />}
        getOptionValue={(user) => (user.user_id)}
        filterOption={() => true} // Filtering happens on the server side
        components={{
          Control,
          Menu,
          Option,
          Placeholder,
          SingleValue,
          ValueContainer,
          NoOptionsMessage,
        }}
        value={value}
        onInputChange={this.handleChange}
        onChange={onSelect}
        placeholder="Type a name or email"
        isClearable
      />
    )
  }
}

export default connect(
  UserSelectContainer.mapStateToProps,
  UserSelectContainer.mapDispatchToProps,
)(withStyles(UserSelectContainer.styles)(UserSelectContainer))
